<template>
    <div class="col-md-12">
        <div class="flash-message">
            <FlashMessage :position="'top'"></FlashMessage>
        </div>
        <form @submit.prevent="updateDriver">
            <div class="container-fluid bg-light py-3">
                <div class="row">
                    <div class="col-md-3">
                        <div class="h2">#{{ driver.name }}</div>
                    </div>
                </div>
            </div>

            <div class="container-fluid bg-light py-3">
                <div class="controls">
                    <div class="row">
                        <div class="col-sm-4">
                            <div class="form-group">
                                <label for="driver-name">
                                    <strong>Name</strong>
                                </label>
                                <div class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                     :class="driver.name=='' && isSubmit? 'border-danger':''">
                                    <input type="text" autocomplete="none" required
                                           class="form-control border-0 py-0 shadow-none form-input"
                                           placeholder="Driver name"
                                           id="driver-name"
                                           v-model="driver.name">
                                    <div class="help-block with-errors"></div>
                                </div>
                            </div>

                            <div class="form-group">
                                <label for="driver-company">
                                    <strong>Company</strong>
                                </label>
                                <div class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                     :class="driver.company_name_id == '' && isSubmit? 'border-danger':''">
                                    <select required class="form-control border-0 py-0 shadow-none pr-5"
                                            id="driver-company"
                                            v-model="driver.company_name_id">
                                        <option :value="companyName.id" v-for="(companyName, index) in companyNames">
                                            {{ companyName.name }}
                                        </option>
                                    </select>
                                </div>
                            </div>

                            <div class="form-group">
                                <label for="driver-phone">
                                    <strong>Phone</strong>
                                </label>
                                <div class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                     :class="driver.phone=='' && isSubmit? 'border-danger':''">
                                    <input type="text" autocomplete="none"
                                           class="form-control border-0 py-0 shadow-none form-input"
                                           placeholder="Phone"
                                           id="driver-phone"
                                           v-model="driver.phone">
                                    <div class="help-block with-errors"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="clearfix"></div>

                <div class="row">
                    <div class="col-md-12">
                        <button type="submit" class="btn btn-primary" @click="validation()">Save</button>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <p class="text-muted"></p>
                    </div>
                </div>
            </div>

        </form>

        <br/>

        <a href="/drivers" title="Back" class="text-decoration-none">
            <button class="btn default btn-sm d-flex align-items-center">
                <span class="material-icons-outlined cursor-pointer text-primary">arrow_back</span>
                <span class="pl-1">Back</span>
            </button>
        </a>
    </div>
</template>
<script>

import companyNamesMixin from "../mixins/companyNamesMixin";
export default {
    name: "DriverEdit",
    mixins: [companyNamesMixin],
    props: {
        driverProp: {type: Object, required: true},
        driverTypeExternal: {type: Number, required: true},
    },
    data() {
        return {
            driver: this.driverProp,
            warehouses: {},
            isSubmit: false,
            companyNames: []
        }
    },
    methods: {
        validation() {
            this.isSubmit = true;
        },
        updateDriver() {
            axios.patch(`/drivers/${this.driver.id}`, this.driver).then((response) => {
                window.location.href = '/drivers';
            }).catch((err) => {
                console.log(err.response);
                this.flashMessage.error({
                    title: '',
                    message: err.response.data.message,
                    time: 2000,
                    blockClass: 'flash-message error'
                });
            })
        },
    },
    created() {
        this.getCompanyNames(this.driverTypeExternal);
    },
}
</script>
